import React from 'react';
import classNames from 'classnames';

import propTypes from 'prop-types';
import PriceSpan from 'common/components/formatters/PriceSpan';
import { TranslatedMessage } from 'common/components/Intl';

export default class VariantPrice extends React.Component {
  static propTypes = {
    baseAmount: propTypes.number.isRequired,
    isMembershipOrder: propTypes.bool.isRequired,
    membershipDiscountRate: propTypes.number.isRequired,
    isSubscribable: propTypes.bool.isRequired,
    commitmentMonths: propTypes.number,
    commitmentPrice: propTypes.number,
    userAmount: propTypes.number.isRequired,
    showStrikethroughPrices: propTypes.bool.isRequired,
  };

  get isMembershipPrice() {
    const { isSubscribable, isMembershipOrder, commitmentMonths } = this.props;
    const isSubscribableInMembershipOrder = isSubscribable && isMembershipOrder;
    return isSubscribableInMembershipOrder && !commitmentMonths;
  }

  get amount() {
    const { commitmentPrice, membershipDiscountRate, userAmount } = this.props;

    if (this.props.commitmentMonths) {
      return commitmentPrice;
    }

    return this.isMembershipPrice
      ? userAmount * (1 - membershipDiscountRate)
      : userAmount;
  }

  render() {
    const {
      priceUnitString,
      commitmentPrice,
      preSalePrice,
      showStrikethroughPrices,
    } = this.props;

    const displayUnitString =
      commitmentPrice && priceUnitString ? `/${priceUnitString}` : '';

    if (preSalePrice && preSalePrice > this.amount) {
      return showStrikethroughPrices ? (
        <>
          <PriceSpan
            className={classNames('heading--title--medium', {
              'autoship-text': this.props.commitmentMonths,
            })}
            amount={this.amount}
          />
          <PriceSpan
            amount={preSalePrice}
            className="product-information__price--discount"
          />
        </>
      ) : (
        <>
          <TranslatedMessage
            id={`page.shop.product_display.pre_sale_pricing.real_price`}
            className="product-information__price--small"
            values={{
              real_price: (
                <PriceSpan
                  className={classNames('heading--title--medium', {
                    'autoship-text': this.props.commitmentMonths,
                  })}
                  amount={this.amount}
                />
              ),
            }}
          />
          <span className={classNames('text--small')}>{displayUnitString}</span>
          <div className="product-information__price--small">
            <TranslatedMessage
              id={`page.shop.product_display.pre_sale_pricing.pre_sale_price`}
              values={{
                pre_sale_price: <PriceSpan amount={preSalePrice} />,
              }}
            />
          </div>
        </>
      );
    }

    return (
      <>
        <PriceSpan
          className={classNames({
            'autoship-text': this.props.commitmentMonths,
          })}
          amount={this.amount}
        />
        <span className={classNames('text--small')}>{displayUnitString}</span>
      </>
    );
  }
}
